import { env } from '@/config/env';

const DEFAULT_RECOMMENDED_ARCHICAD_PLUGIN_VERSION = '2.0.0';

export function getRecommendedArchicadPluginVersion(): string {
  return (
    env.NEXT_PUBLIC_ARCHICAD_PLUGIN_RECOMMENDED_VERSION ??
    DEFAULT_RECOMMENDED_ARCHICAD_PLUGIN_VERSION
  );
}
